import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';

import {
    LOADING,
    LOAD_COLLECTION_SETTINGS_SUCCESS,
    UPDATE_COLLECTION_SETTINGS_SUCCESS,
    RESET_COLLECTION_SETTINGS
} from '../../../types';
import MessageUtils from "../../../../utils/MessageUtils";
import { doLoadOpeningHours } from '../../../index';

export const loadCollectionSettings = (restaurantId) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/collection`;

        axios().get(url)
            .then(response => loadCollectionSettingsSuccess(dispatch, response, getState, restaurantId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:deliveryActions.loadSettingsFailure')));
    }
}

const loadCollectionSettingsSuccess = (dispatch, response, getState, restaurantId) => {
    if (response.status === 204) {
        const saveDataToScreen = 'collection';
        doLoadOpeningHours(restaurantId, dispatch, getState, saveDataToScreen);
    }

    dispatch({ type: LOADING, payload: false });
    
    if (response.status !== 204) {
        dispatch({ type: LOAD_COLLECTION_SETTINGS_SUCCESS, payload: response.data });
    }
}

export const updateCollectionSettings = (restaurantId, state, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/settings/${restaurantId}/collection`;

        const collectionSettings = {
            id: state.id,
            preparationTimes: state.preparationTimes,
            supportedTenderTypes: state.supportedTenderTypes,
            minimumOrderAmount:
                (state.minimumOrderAmount === undefined || state.minimumOrderAmount === null || state.minimumOrderAmount === '') ?
                    1 : Number(state.minimumOrderAmount),
            maximumOrderAmount:
                (state.maximumOrderAmount === undefined || state.maximumOrderAmount === null || state.maximumOrderAmount === '') ?
                    null : Number(state.maximumOrderAmount),
            serviceNote: state.serviceNote,
            timeSlots: state.timeSlots,
            nextDayOrdersOnly: state.nextDayOrdersOnly,
            nextDayOrdersNumber: state.nextDayOrdersNumber
        };

        axios().post(url, collectionSettings)
            .then(response => updateCollectionSettingsSuccess(dispatch, response, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.saveFailure')));
    }
}

const updateCollectionSettingsSuccess = (dispatch, response, callback) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_COLLECTION_SETTINGS_SUCCESS, payload: response.data });
    if (callback) {
        callback();
    }
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
}

export const resetCollectionSettings = () => {
    return (dispatch) => {
        dispatch({ type: RESET_COLLECTION_SETTINGS });
    }
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/CollectionActions.js